export type PhaseAdvanceWhen = 'date' | 'previous_sold_out' | 'previous_expired' | 'manual';

export const PHASE_ADVANCE_OPTIONS: {
  value: PhaseAdvanceWhen;
  label: string;
  hint: string;
}[] = [
  {
    value: 'date',
    label: 'Por data e hora',
    hint: 'Você define quando este lote abre e fecha.',
  },
  {
    value: 'previous_sold_out',
    label: 'Quando esgotar o lote anterior',
    hint: 'Abre automaticamente quando as vagas do lote anterior acabarem. Só defina o fim deste lote.',
  },
  {
    value: 'previous_expired',
    label: 'Quando expirar o lote anterior',
    hint: 'Abre quando terminar o prazo do lote anterior. Só defina o fim deste lote.',
  },
  {
    value: 'manual',
    label: 'Manual',
    hint: 'Você abre este lote manualmente no painel. Só defina o fim deste lote.',
  },
];

export function isEventDrivenAdvance(advanceWhen?: string): boolean {
  return (
    advanceWhen === 'previous_sold_out' ||
    advanceWhen === 'previous_expired' ||
    advanceWhen === 'manual'
  );
}

export function addDays(date: Date, days: number): Date {
  return new Date(date.getTime() + days * 86400000);
}

export function diffDays(start: Date, end: Date): number {
  const ms = end.getTime() - start.getTime();
  return Math.max(1, Math.round(ms / 86400000));
}

export function defaultPhaseDates(
  prevEnd?: Date | null,
  durationDays = 7
): { start: Date; end: Date } {
  const start = prevEnd ? new Date(prevEnd) : new Date();
  return { start, end: addDays(start, durationDays) };
}

export function getAdvanceHint(advanceWhen?: string, prevPhaseName?: string): string {
  const option = PHASE_ADVANCE_OPTIONS.find((o) => o.value === advanceWhen);
  if (!option) return '';
  if (prevPhaseName && advanceWhen !== 'date') {
    return `${option.hint} (aguarda: ${prevPhaseName})`;
  }
  return option.hint;
}

export function formatPhaseDateShort(value?: Date | string | null): string {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
